import { BackendRoute } from '../../../config/index';
import { QueryKey } from '../../../constants/index';
import { useAppQuery } from '../../../hooks/use-app-query.hook';
import { ApiService } from '../../../services/index';
import { selectedCompanyStorage } from '../../../storage/company/selected-company.util';
import { SPACES_STALE_TIME_MS } from '../constants/spaces-query.const';

type RecipientDataRoom = { description: null | string; id: string; name: string };

export const useRecipientDataRoom = (id: string | undefined) => {
  const companyId = selectedCompanyStorage(({ companyId: selected }) => selected);

  const { data, isPending } = useAppQuery({
    enabled: !!id,
    queryFn: () =>
      ApiService.get<RecipientDataRoom>({ endpoint: BackendRoute.MY_DATA_ROOMS, routePath: [id!] }),
    queryKey: [QueryKey.MY_DATA_ROOMS_NAVIGATION, companyId, id],
    staleTime: SPACES_STALE_TIME_MS,
  });

  return { dataRoom: data, isPending };
};
